export default "__VITE_ASSET__CsMYEow7__"